<template>
  <div class="subHeader">
    <div class="title"
         :style="hideBox?'border-bottom:none':''">
      <slot name="title"></slot>
      <span>
        <slot name="btn"></slot>
      </span>
    </div>
    <div class="box"
         v-if="!hideBox">
      <div class="tab">
        <slot name="tab"></slot>
      </div>
      <div class="search">
        <slot name="search"></slot>
      </div>
      <div class="tab-btn">
        <slot name="tab-btn"></slot>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    hideBox: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {

  },
  components: {

  }
}
</script>
<style lang="scss">
.subHeader {
  .el-tabs {
    .el-tabs__header {
      margin-bottom: 0;
    }
  }
}
</style>
<style scoped lang="scss">
.subHeader {
  margin-bottom: 8px;
  padding: 0 16px;
  background-color: #fff;
  box-shadow: 0px 2px 3px 0px #ddd;
  overflow: hidden;
  flex-shrink: 0;
  .title {
    height: 75px;
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    border-bottom: 1px solid #dcdfe6;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-breadcrumb {
      font-size: 18px;
    }
  }
  .box {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .search {
      flex-grow: 2;
      .el-input {
        width: 320px;
        height: 28px;
      }
    }
    .tab-btn {
      display: flex;
    }
  }
}
</style>
